import React, { Component } from 'react';
import { connect } from 'react-redux';
import TextInput from '../../../../../../../components/ZUILib/TextInput';
import CheckBox from '../../../../../../../components/ZUILib/CheckBox';
import InputButton from '../../../../../../../components/ZUILib/InputButton';
import commonUtil from '../../../../../../../utils/commonUtil';
import { constEventStatus, eventType } from '../../../../../../../utils/clientConstant';
const errorObject = require('../../../../../../../utils/errors/LP_GR_error.json');

const channel = commonUtil.getChannel();
class PartnerForm extends Component {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.state = {
            // Initialize your state here
            title: props.partnerData?.title || '',
            PartnerFormdata: props.partnerData || {},
            initialFormdata: props.partnerData || {},
            disableSubmit: true,
            disableCancel: true,
            initialPartnerPhone: props.partnerData?.phone || '',
            initialPartnerEmail:props.partnerData?.email || '',
            enableCheckBox: props.partnerData?.hasPermission || false,
            enableCreateForm: false,
            hidetheSubmitButton : true,
            emailErrorCelebrity: ''
        };
        // this.checkBoxSelected = '';
    }

    componentDidMount() {
        this.setState({
            title: this.props.partnerData?.title || '',
            PartnerFormdata: this.props.partnerData,
            initialFormdata: this.props.partnerData,
            initialPartnerPhone: this.props.partnerData?.phone || '',
            enableCheckBox: this.props.partnerData?.hasPermission || false,
            initialPartnerEmail:this.props.partnerData?.email || '',
            enableCreateForm: false
        });
          if(channel === 'wap') {
             document.addEventListener('click', this.handleClickOutside);
          }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.partnerData !== this.props.partnerData) {
            this.setState({
                title: this.props.partnerData?.title || '',
                PartnerFormdata: this.props.partnerData,
                initialFormdata: this.props.partnerData,
                initialPartnerPhone: this.props.partnerData?.phone || '',
                enableCheckBox: this.props.partnerData?.hasPermission || false,
                initialPartnerEmail:this.props.partnerData?.email || '',
                enableCreateForm: false
            });
        }

        if (prevProps.emailErrorCelebrity !== this.props.emailErrorCelebrity) {
            this.setState({
                 emailErrorCelebrity: this.props.emailErrorCelebrity || ''
            });
        }
    }

    checkboxHandler = (data) => {         
        const currentValue = this.state.enableCheckBox;
        const { PartnerFormdata,initialFormdata,enableCreateForm, } = this.state;
        console.log(data,PartnerFormdata?.hasPermission)

        if(enableCreateForm && !data.checked){
            //if user is in create mode and uncheck the checkbox then clear the phone and email field
            this.props.setEmailErrorCelebrity('');
            this.setState((prevState) => ({
                initialFormdata: {
                    ...prevState.initialFormdata,
                    phone: '',
                    email: ''
                },
                emailErrorCelebrity: ''
            }))
        }

        const phoneValue = PartnerFormdata.phone ?? '';
        const emailValue = PartnerFormdata.email ?? '';

        const isCheckboxPermissionSameAsInitial = initialFormdata && (initialFormdata.hasPermission === data.checked);

        const disableEditCancel = (((initialFormdata.email ?? '') != emailValue) || ((initialFormdata.phone ?? '') != phoneValue)) || !isCheckboxPermissionSameAsInitial ? false : true;
        let disableEditSubmit = ((initialFormdata.email ? true : ((initialFormdata.email ?? '') != emailValue)) && ((initialFormdata.phone ?? '') != phoneValue)) || !isCheckboxPermissionSameAsInitial ? false : true;

        if(emailValue == "" || phoneValue == ""){
            disableEditSubmit = true;
        }
        
        if (enableCreateForm) {
            const firstNameHasValue = (initialFormdata.firstName && initialFormdata.firstName.trim().length > 0);
            const lastNameHasValue = (initialFormdata.lastName && initialFormdata.lastName.trim().length > 0);
            const motherNameHasValue = (initialFormdata.motherName && initialFormdata.motherName.trim().length > 0);
            const phoneHasValue = data.checked ? (initialFormdata && initialFormdata.phone && initialFormdata.phone.trim().length > 0) : false;
            const emailHasValue = data.checked ? (initialFormdata && initialFormdata.email && initialFormdata.email.trim().length > 0) : false;

            if (firstNameHasValue || lastNameHasValue || motherNameHasValue || (data.checked ? (phoneHasValue || emailHasValue) : false)) {
                this.disableCancelButton(false);
            } else {
                this.disableCancelButton(true);
            }

            if(firstNameHasValue && lastNameHasValue && (data.checked ? (phoneHasValue && emailHasValue) : true)){
                this.disableSubmitButton(false);
            } else {
                this.disableSubmitButton(true);
            }

            this.setState({
                enableCheckBox: !currentValue,
                hidetheSubmitButton: false
            });
        } else if (initialFormdata && initialFormdata.hasPermission == data.checked && !enableCreateForm) {
            //if checkbox is already selected and user is not in create mode then do not change the value
            this.setState({
                disableSubmit: disableEditSubmit,
                disableCancel: disableEditCancel,
                enableCheckBox: !currentValue,
                hidetheSubmitButton: true,
            });

        } else if (initialFormdata && ((initialFormdata.email ?? '') === '' || (initialFormdata.phone ?? '') === '') && data.checked && !enableCreateForm) {
            this.setState({
                enableCheckBox: !currentValue,
                disableSubmit: disableEditSubmit,
                disableCancel: disableEditCancel,
                hidetheSubmitButton: false
            });
        } else {
            this.setState({
                enableCheckBox: !currentValue,
                disableSubmit: enableCreateForm ? false : disableEditSubmit,
                disableCancel: enableCreateForm ? false : disableEditCancel,
                hidetheSubmitButton: false
            });
        } 
        
    }
    updatePartnerData = (e) => {
        const { enableCreateForm, initialPartnerPhone, initialPartnerEmail, PartnerFormdata } = this.state;
        //check wthere edit or create based on enableCreateForm flag
        if (enableCreateForm) {
            this.createPartnerData(e)
        }
        else {
            const { name, value } = e.target;

            if(name === 'email' && value !== PartnerFormdata.email){
                this.props.setEmailErrorCelebrity('');
                this.setState({
                    emailErrorCelebrity: ''
                })
            }

            this.setState((prevState) => ({
                PartnerFormdata: {
                    ...prevState.PartnerFormdata, // Spread previous formData
                    [name]: value, // Update only the specific field
                }
            }), () => {
                const phoneHasValue = PartnerFormdata.phone && PartnerFormdata.phone.trim().length > 0;
                const emailHasValue = PartnerFormdata.email && PartnerFormdata.email.trim().length > 0;

                if(((name === 'phone' ? (initialPartnerPhone !== value && value.length > 0) : (initialPartnerPhone !== PartnerFormdata.phone && phoneHasValue)) || (name === 'email' ? (initialPartnerEmail !== value && value.length > 0) : (initialPartnerEmail !== PartnerFormdata.email && emailHasValue)))){
                    this.disableCancelButton(false);
                } else {
                    this.disableCancelButton(true);
                }
                
                if (name === 'phone' && initialPartnerPhone !== value && value.length > 0 && emailHasValue) {
                    this.disableSubmitButton(false)

                }else if(name === 'email' && initialPartnerEmail !== value && value.length > 0 && phoneHasValue){
                    this.disableSubmitButton(false)
                }
                else {
                    this.disableSubmitButton(true)

                }
            });
        }

    }
    createPartnerData = (e) => {
        const {initialFormdata, enableCheckBox } = this.state;

        const { name, value } = e.target;
        if(name === 'email' && value !== initialFormdata.email){
            this.props.setEmailErrorCelebrity('');
            this.setState({
                emailErrorCelebrity: ''
            })
        }

        this.setState((prevState) => ({
            initialFormdata: {
                ...prevState.initialFormdata, // Spread previous formData
                [name]: value, // Update only the specific field
            }
        }), () => {

            const firstNameHasValue = (name == 'firstName') ? value.length > 0 : (initialFormdata.firstName && initialFormdata.firstName.trim().length > 0);
            const lastNameHasValue = (name == 'lastName') ? value.length > 0 : (initialFormdata.lastName && initialFormdata.lastName.trim().length > 0);

            const motherNameHasValue = (name == 'motherName') ? value.length > 0 : (initialFormdata.motherName && initialFormdata.motherName.trim().length > 0);

            const phoneHasValue = (name == 'phone') ? value.length > 0 : (initialFormdata && initialFormdata.phone && initialFormdata.phone.trim().length > 0);
            const emailHasValue = (name == 'email') ? value.length > 0 : (initialFormdata && initialFormdata.email && initialFormdata.email.trim().length > 0);

            if (firstNameHasValue || lastNameHasValue || motherNameHasValue || (enableCheckBox ? (phoneHasValue || emailHasValue) : false)) {
                this.disableCancelButton(false);
            } else {
                this.disableCancelButton(true);
            }

            if(firstNameHasValue && lastNameHasValue && (enableCheckBox ? (phoneHasValue && emailHasValue) : true)){
                this.disableSubmitButton(false);
            } else {
                this.disableSubmitButton(true);
            }
        });
    }

    hidetheSubmitButton = (val) => {
        this.setState({
            hidetheSubmitButton: val
        })
    }

    disableSubmitButton = (val) => {
        this.setState({
            disableSubmit: val
        })
    }

    disableCancelButton = (val) => {
        this.setState({
            disableCancel: val
        })
    }

    SubmitPartnerInfo = () => {
        const { enableCreateForm, PartnerFormdata,enableCheckBox,initialFormdata } = this.state;
        //check wthere edit or create based on enableCreateForm flag 
        console.log(enableCreateForm,enableCheckBox)
        let hasPermission = false;
        if (enableCreateForm) {
            
            if (enableCheckBox) {
                    hasPermission = true;
            }
            const payload = {

                "ownerTitle": initialFormdata?.title || '',
                "ownerHasPermission": hasPermission,
                "ownerfirstName": initialFormdata.firstName,
                "ownerlastName": initialFormdata.lastName,
                "ownerMotherName": initialFormdata.motherName,
                "ownerPhone": hasPermission ? initialFormdata.phone :"",
                "ownerEmail": hasPermission ? initialFormdata.email :"",
                "iscoOwner" : true
            }
            console.log({payload})
            this.props.createpartnerDetails(payload);
            this.disableSubmitButton(true)
            this.disableCancelButton(true)
            this.hidetheSubmitButton(true)
        } else {
              let hasPermission = false;
              console.log({enableCheckBox})
              if (enableCheckBox) {
                    hasPermission = true;
                }
            const payload = {
                "ownerId": PartnerFormdata.repositoryId,
                "ownerTitle": PartnerFormdata.title,
                "ownerHasPermission": hasPermission,
                "ownerfirstName": PartnerFormdata.firstName,
                "ownerlastName": PartnerFormdata.lastName,
                "ownerMotherName": PartnerFormdata.motherName,
                "ownerPhone": hasPermission ? PartnerFormdata.phone :"",
                "ownerEmail": hasPermission ? PartnerFormdata.email :""
            }
            console.log({payload})

            this.props.updateOwnerDetails(payload);
            this.disableSubmitButton(true)
            this.disableCancelButton(true)
            this.hidetheSubmitButton(true)
        }
    }
    resetCreatePartnerForm = () => {
         const { enableCreateForm} = this.state;
        if(enableCreateForm){
            this.props.setEmailErrorCelebrity('');
            this.setState({
                initialFormdata:{},                
                enableCreateForm: false,
                enableCheckBox: false,
                disableSubmit: true,
                disableCancel: true,
                emailErrorCelebrity: '',
            })
        }
    }
    resetPartnerForm = () => {
        const { initialFormdata } = this.state;
        this.setState({
            PartnerFormdata: initialFormdata,
            enableCheckBox: initialFormdata.hasPermission,
            disableSubmit: true,
            disableCancel: true,
            hidetheSubmitButton: initialFormdata.hasPermission ? false : true,
        })
    }

    createpartnerForm = () => {
        this.setState({
            enableCreateForm: true,
            disableCancel: false,
        })
    }
    validate = () => {
        const { PartnerFormdata, enableCreateForm, enableCheckBox,initialPartnerEmail } = this.state;
        const phoneNumber = PartnerFormdata.phone;
        const configurationNumber = Number(commonUtil.getLabel(this.props.lables?.createEventStep1, 'createEventStep1.inputconfiguration.number'));

        if (enableCreateForm) {
            //validate the create form
            //fisrtname
            const firstNameValidationRules = [
                 { functionRef: commonUtil.validateLength, funcData: [this.partnerFirstname.getValue(),configurationNumber], errorMessage: commonUtil.getError(errorObject.DatosDeMiEvento, 'DatosDeMiEvento.error.minthreelentgh') },
                { functionRef: commonUtil.isValueAvailable, funcData: [this.partnerFirstname.getValue()], errorMessage: commonUtil.getError(errorObject.DatosDeMiEvento, 'DatosDeMiEvento.firstName.error.required') },
                { functionRef: commonUtil.validateName, funcData: [this.partnerFirstname.getValue(), 1, true], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },

            ];
            const firstNameValid = commonUtil.validateTextInput(firstNameValidationRules, this.partnerFirstname, null);



            const lastNameValidationRules = [
                { functionRef: commonUtil.validateLength, funcData: [this.partnerlastName.getValue(),configurationNumber], errorMessage: commonUtil.getError(errorObject.DatosDeMiEvento, 'DatosDeMiEvento.error.minthreelentgh') },
                { functionRef: commonUtil.isValueAvailable, funcData: [this.partnerlastName.getValue()], errorMessage: commonUtil.getError(errorObject.DatosDeMiEvento, 'DatosDeMiEvento.lastName.error.required') },
                { functionRef: commonUtil.validateName, funcData: [this.partnerlastName.getValue(), 1, true], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },

            ];
            const lastNameValid = commonUtil.validateTextInput(lastNameValidationRules, this.partnerlastName, null);
            
            let motherValidName = true;
            if(this.partnermotherName.getValue() && this.partnermotherName.getValue().length > 0){
                        const motherNameValidation = [
                            { functionRef: commonUtil.validateLength, funcData: [this.partnermotherName.getValue(), configurationNumber], errorMessage: commonUtil.getError(errorObject.DatosDeMiEvento, 'DatosDeMiEvento.error.minthreelentgh') },
                            { functionRef: commonUtil.validateName, funcData: [this.partnermotherName.getValue(), 1, true], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },

                        ];
                        motherValidName = commonUtil.validateTextInput(motherNameValidation, this.partnermotherName, null);
        }
            if (!firstNameValid || !lastNameValid || !motherValidName) {
                return false
            }

            // console.log('lastNameValid', lastNameValid, 'firstNameValid', firstNameValid);  
            // return false;

            let phoneNumberValid = true;
            let emailValid = true;
            //phone number validation
            //while creating if checkbox is selected then only validate the phone number 
            if (enableCheckBox) {
                const phoneNumberValidationRules = [
                    { functionRef: commonUtil.isValueAvailable, funcData: [this.partnerPhone.getValue()], errorMessage: commonUtil.getError(errorObject.AddAddress, 'AddAddress.error.phone.required.field') },
                    { functionRef: commonUtil.validateNumber, funcData: [this.partnerPhone.getValue()], errorMessage: commonUtil.getError(errorObject.AddAddress, 'AddAddress.error.phone.invalid.field') },
                ];
                phoneNumberValid = commonUtil.validateTextInput(phoneNumberValidationRules, this.partnerPhone, null);

                const emailValidationRules = [
                    // { functionRef: commonUtil.compareEmail, funcData: [this.partnerEmail.getValue(), this.ownerEmailId], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.emailMatch.error') },
                    { functionRef: commonUtil.isValueAvailable, funcData: [this.partnerEmail.getValue()], errorMessage: commonUtil.getError(errorObject.DatosDeMiEvento, 'DatosDeMiEvento.email.error.required') },
                    { functionRef: commonUtil.validateEmail, funcData: [this.partnerEmail.getValue(), 3], errorMessage: commonUtil.getError(errorObject.DatosDeMiEvento, 'DatosDeMiEvento.email.error.invalid') },
                ];
                emailValid = commonUtil.validateTextInput(emailValidationRules, this.partnerEmail, null);

                if (!phoneNumberValid || !emailValid) {
                    return false
                }

                
            }
             this.SubmitPartnerInfo();
           
        } else {
            //update the form
            if (!enableCheckBox) {
                this.SubmitPartnerInfo()
            } else {
                let phoneNumberValid = true;
                //phone number validation
                 
                    const phoneNumberValidationRules = [
                        { functionRef: commonUtil.isValueAvailable, funcData: [this.partnerPhone.getValue()], errorMessage: commonUtil.getError(errorObject.AddAddress, 'AddAddress.error.phone.required.field') },
                        { functionRef: commonUtil.validateNumber, funcData: [this.partnerPhone.getValue()], errorMessage: commonUtil.getError(errorObject.AddAddress, 'AddAddress.error.phone.invalid.field') },
                    ];
                    phoneNumberValid = commonUtil.validateTextInput(phoneNumberValidationRules, this.partnerPhone, null);
                    if (!phoneNumberValid) {
                        return false
                    }
                

                if (initialPartnerEmail == '') {
                    let emailValid = true;
                    const emailValidationRules = [
                        // { functionRef: commonUtil.compareEmail, funcData: [this.partnerEmail.getValue(), this.ownerEmailId], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.emailMatch.error') },
                        { functionRef: commonUtil.isValueAvailable, funcData: [this.partnerEmail.getValue()], errorMessage: commonUtil.getError(errorObject.DatosDeMiEvento, 'DatosDeMiEvento.email.error.required') },
                        { functionRef: commonUtil.validateEmail, funcData: [this.partnerEmail.getValue(), 3], errorMessage: commonUtil.getError(errorObject.DatosDeMiEvento, 'DatosDeMiEvento.email.error.invalid') },
                    ];
                    emailValid = commonUtil.validateTextInput(emailValidationRules, this.partnerEmail, null);

                    if (!emailValid) {
                        return false;
                    }
                }
                 this.SubmitPartnerInfo()
            }
           
            // this.resetPartnerForm();
        }


        
    }

    componentWillUnmount() {
     if (channel === 'wap') {
        document.removeEventListener('click', this.handleClickOutside);
      }
  }

    handlePopUpCoOwner = (e ,id) => {
        if(channel === 'wap'){
            e.stopPropagation();
            e.preventDefault();
        const data = document.querySelector('#' + id);
        if (data.style.display === 'block') {
            data.style.display = 'none';
        } else {
            data.style.display = 'block';
        }
    }
    }

  handleClickOutside = (event) => {
    if (channel === 'wap') {
      const tooltip = document.querySelector('#helpPopupPartner');
      if (tooltip && !tooltip.contains(event.target) && tooltip.style.display === 'block') {
        tooltip.style.display = 'none';
      }
    }
  }

    render() {
        const { partnerData, EventTypeProps,lables} = this.props;
         const isTemporaryClosed =  (this.props.eventStatus && (this.props.eventStatus === constEventStatus.TEMPORARYCLOSED)|| (this.props.eventStatus === constEventStatus.SUSPENDED) || (this.props.eventStatus === constEventStatus.CLOSED));
        // Handler to update state on input change
        const { title,enableCheckBox, PartnerFormdata, disableSubmit, disableCancel, hidetheSubmitButton, enableCreateForm, initialPartnerEmail, emailErrorCelebrity , initialPartnerPhone} = this.state;
        let actualizarDatos = {
            id: 'updateData',
            type: 'button',
            name: 'Guardar cambios',
            value: commonUtil.getLabel(lables.EventAdminPage,'adminpage.button.save.changes'),
            classname: 'personal-data-button',
            onClickHandler: () => {
                // Handle clear filter action
                this.validate()

            },
            disabled: disableSubmit,
            autoFocus: false,
            ariaLabel: 'update personal data',
            ariaHidden: false,
            cssStyle : !disableSubmit ? {backgroundColor : this.props.selectedTheme?.color_500,color : "#fff"} : ""
        };

        let cancelButton = {
            className: 'personal-data-cancel-button',
            name: 'Cancelar',
            type: 'button',
            value: commonUtil.getLabel(lables.EventAdminPage,'adminpage.button.cancel.data'),
            disabled: disableCancel , 
            autoFocus: false,
            style: 'personal-data-cancel-button',
            onClickHandler: () => {
                this.resetPartnerForm();
            },
            cssStyle : !disableCancel ? { border: `2px solid ${this.props.selectedTheme?.color_500 }`,color : this.props.selectedTheme?.color_500 } : ""
        };
        let createCancelButton = {
            className: 'personal-data-cancel-button',
            name: 'Cancelar',
            type: 'button',
            value: commonUtil.getLabel(lables.EventAdminPage,'adminpage.button.cancel.data'),
            disabled: disableCancel, 
            autoFocus: false,
            style: 'personal-data-cancel-button',
            onClickHandler: () => {
                this.resetCreatePartnerForm();
            },
            cssStyle : !disableCancel ? { border: `2px solid ${this.props.selectedTheme?.color_500 }`,color : this.props.selectedTheme?.color_500 } : ""
        };

        let createAdministator = {
            disabled: isTemporaryClosed,
            classname: 'personal-data-create-admin-button',
            name: 'Agregar organizador',
            type: 'button',
            value: commonUtil.getLabel(lables.EventAdminPage,'adminpage.add.organizer'),
            autoFocus: false,
            onClickHandler: () => {
                this.createpartnerForm();
            },
            cssStyle : isTemporaryClosed ? { border: `2px solid #d8d8d8 }`,color : "#d8d8d8" } : { border: `2px solid ${this.props.selectedTheme?.color_500 }`,color : this.props.selectedTheme?.color_500 }
        };
        return (

            <div className="personal-data-container col-md-6 col-sm-12 col-xs-12"
                style={{ display: 'flex' }}
            >
                {(enableCreateForm || partnerData && Object.keys(partnerData).length > 0) ? <div className='personal-data-partner-section'  >
                    <div className='required-field-lable'>
                        {enableCheckBox && "*Campos obligatorios"}
                    </div>
                    <div className='personal-data-title'

                    >
                        {(
                            EventTypeProps === eventType.Boda
                                ? commonUtil.getLabel(lables.EventAdminPage, 'adminpage.partner.info.lable')
                                : commonUtil.getLabel(lables.EventAdminPage, 'adminpage.organizer.two.lable')
                        )}
                    </div>
                    <TextInput
                        className="inputMaterial"
                        labelClassName="placeHolderMaterial"
                        htmlId="partnerName"
                        label={(EventTypeProps === eventType.Boda) ? "Nombre(s) de tu pareja" : "Nombre"}
                        name="firstName"
                        required="true"
                        star="*"
                        maxlength="100"
                        //vallue is for default val
                        value={!enableCreateForm && PartnerFormdata?.firstName || ''}
                        onChange={(e) => { this.updatePartnerData(e) }}
                        disabled={!enableCreateForm}
                        ref={el => (this.partnerFirstname = el)}
                    />
                    <TextInput
                        className="inputMaterial"
                        labelClassName="placeHolderMaterial"
                        htmlId="partnerSecondSurname"
                        label="Primer apellido"
                        name="lastName"
                        required="true"
                        star="*"
                        value={!enableCreateForm && PartnerFormdata?.lastName || ''}
                        onChange={(e) => { this.updatePartnerData(e) }}
                        disabled={!enableCreateForm}
                        ref={el => (this.partnerlastName = el)}
                        maxlength="100"
                    />

                    <TextInput
                        className={`inputMaterial ${ PartnerFormdata?.motherName ? '' : 'lastnameInput'}`}
                        labelClassName="placeHolderMaterial"
                        htmlId="partnerFirstSurname"                       
                        label="Segundo apellido"
                        name="motherName" 
                        required="false"                       
                        onChange={(e) => { this.updatePartnerData(e) }}
                        value={!enableCreateForm && PartnerFormdata?.motherName || ''}
                        disabled={!enableCreateForm}
                        ref={el => (this.partnermotherName = el)}
                        maxlength="100"
                    />
                    
                    <div className='personal-data-checkbox-section partnerform-checkbox'>
                        <CheckBox
                            htmlId={'_showEmailPartner'}
                            displayName={<span className='gapLabelWap'>{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.partner.checkbox.label')}</span>}
                            getSelectedValue={this.checkboxHandler}
                            checked={this.state.enableCheckBox}
                            ref={el => (this.CheckBox = el)}
                            customCss={true}
                            disabled={isTemporaryClosed}
                            isSuspended={isTemporaryClosed}
                        />
                        <div className="iconHelp inLine iconHelp-pl iconHelpWrapper">
                            <img src={commonUtil.getAssetURL() + '/images/help.svg'} alt="icon_help" className="icon_help" onClick={(e) => { this.handlePopUpCoOwner(e, 'helpPopupPartner'); }} />
                            <div className="tooltip-backdrop" />
                            <div id="helpPopupPartner" className="popover bottom help-icon-partner">
                                <div className="arrow" />
                                <div className="popover-content">
                                    {"Se enviará un correo electrónico para iniciar sesión o crear una cuenta en Liverpool e ingresar a mesa de regalos Liverpool"}
                                </div>
                            </div>
                        </div>
                    </div>

                    {enableCheckBox &&
                        <>
                            <TextInput
                                className="inputMaterial"
                                labelClassName="placeHolderMaterial"
                                htmlId="Partnerphone"
                                label="Celular"
                                required="true"
                                star="*"
                                name="phone"
                                maxlength="10"
                                onChange={(e) => { this.updatePartnerData(e) }}
                                value={!enableCreateForm && PartnerFormdata && PartnerFormdata?.phone || ''}
                                ref={el => (this.partnerPhone = el)}
                                onKeyDown={(e) => { commonUtil.handleAllowOnlyDigit(e); }}
                                {...(isTemporaryClosed || initialPartnerPhone) ? { disabled: true } : {}}
                            />
                            {/* if partnerData has email already disable it */}
                            {initialPartnerEmail ? 
                                <TextInput
                                className="inputMaterial"
                                labelClassName="placeHolderMaterial"
                                htmlId="email"
                                label="Correo electrónico"                                 
                                maxlength="100"
                                // onChange={(e) => { this.updatePartnerData(e) }}
                                name="email"
                                required="true"
                                star="*"
                                parentClassName={''}
                                disabled={true} 
                                // ref={el => (this.partnerEmail = el)}
                                value={PartnerFormdata && PartnerFormdata?.email || ''}

                            />  
                                
                               : <TextInput
                                className={`inputMaterial ${emailErrorCelebrity ? 'input-error' : ''}`}
                                labelClassName={`placeHolderMaterial ${emailErrorCelebrity ? 'label-error' : ''}`}
                                htmlId="email"
                                label="Correo electrónico"                                 
                                maxlength="100"
                                onChange={(e) => { this.updatePartnerData(e) }}
                                name="email"
                                required="true"
                                star="*"
                                parentClassName={''}
                                // disabled={!enableCreateForm && PartnerFormdata && PartnerFormdata?.email || '' } 
                                ref={el => (this.partnerEmail = el)}
                                value={!enableCreateForm && PartnerFormdata && PartnerFormdata?.email || ''}

                            />
                            }
                            { emailErrorCelebrity && <span className="input-error-message" id="emailError">{emailErrorCelebrity}</span>}
                        </>}
                    <div className="personal-data-button-wrapper">   
                        {
                            enableCreateForm ? (
                            <> <InputButton buttonAttr={createCancelButton} />
                                <InputButton buttonAttr={actualizarDatos} /></>
                            ) : (
                            (!hidetheSubmitButton || enableCheckBox) &&
                            <>
                                <InputButton buttonAttr={cancelButton} />
                                <InputButton buttonAttr={actualizarDatos} />
                            </>
                            )
                        }
                    </div>
                </div> :

                    <div className='personal-data-partner-section'  >
                        <div className='partner-data-no-participant-lable'>
                           {commonUtil.getLabel(lables.EventAdminPage,'adminpage.message.no.participant')}
                        </div>
                        <InputButton buttonAttr={createAdministator} />
                    </div>


                }
            </div>

        );
    }
}

const mapStateToProps = state => {
    labels: state.labels.data
}

export default connect(mapStateToProps)(PartnerForm);
